<template>
    <v-form ref="form_documentos">
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-list two-line subheader>
                        <v-subheader inset>
                            <span>Documentos</span>
                            <span class="ml-2" v-html="`(Tamaño Max. ${(this.parametros.taMaxArchivo/this.numDividir)} MB)`"></span>
                            <v-text-field style="display: none;" :rules="_.size(archivos) > totalFiles ? requeridoRegla : []"/>                            
                        </v-subheader>

                        <v-list-item
                            v-for="item in archivos"
                            :key="item.title"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    :class="[item.iconClass]"
                                    v-text="item.icon"
                                ></v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon ripple v-on="on">
                                                        <v-icon :color="colors" @click="abrirVentana(item.name)"
                                                            v-html="icon_action"></v-icon>
                                                        <input type="file" :id="item.name" style="display: none;" :ref="item.name"
                                                            @change="obtenerFile" accept=".pdf" />
                                                    </v-btn>
                                                </template>
                                                <span>Subir Archivo</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon ripple v-show="item.load" v-on="on">
                                                        <v-icon color="indigo lighten-2 white--text" @click="leerArchivo(item)"
                                                            v-html="'visibility'"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ver Archivo</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12" class="mt-3 mb-3 text-right">
                    <v-btn outlined rounded color="danger" class="mr-1" @click="previous('objArchivos',archivos)">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperDocumentoComponent',
        inject:['previous','next'],
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        props:{
            cargar:{
                type:Boolean,
                default: false
            },
            objForm:{
                type:Object,
                default:{}
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            numDividir: 1000000,
            totalFiles: 0,
            icon_action: 'cloud_upload',
            colors: "grey lighten-1",
            archivos: {},
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            }
        }),
        watch:{
            cargar(val){
                if (val && _.size(this.archivos) == 0) {
                    this.onListarCatalogoDocumentos('L');
                }
            }
        },
        methods:{
            onListarCatalogoDocumentos(event){
                if(!_.isUndefined(event)){
                    this.totalFiles = 0;
                    var error = 'E';
                    var o = {
                                    opcion          : 'L',
                                    idTipoDocumento : _.get(this.parametros,'idTipoDocPlaContratante',null),
                                    idFormulario    : _.get(this.objForm,'idFormulario',null),
                                    idEstado        : _.get(this.parametros,'idEstadoDefault',null)
                                };

                    axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar-documentos`,o)
                         .then((r) => {
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }

                                var l = _.filter(r.data.data, (v) => {  return !_.includes(_.toLower(v.documento),'formulario');});
                                _.forEach((l), (v,k) =>{
                                    var id = _.camelCase(v['documento']);
                                    this.totalFiles += _.size(v['idSecDocumento']) > 0 ? 1 : 0;

                                    this.$set(this.archivos,id,{
                                        'id'                : v['idDocumento'],
                                        'idSecDocumento'    : v['idSecDocumento'],
                                        'name'              : id,
                                        'title'             : v['documento'] ,
                                        'nameFile'          : v['nombreArchivo'],
                                        'subtitle'          : v['nombreArchivo'],
                                        'icon'              : 'folder',
                                        'path'              : v['path'],
                                        'band'              : _.size(v['idSecDocumento']) > 0 ? true : false,
                                        'iconClass'         : _.size(v['path']) > 0 ? 'indigo lighten-2 white--text' : 'grey lighten-1 white--text',
                                        'load'              : _.size(v['path']) > 0 ? true : false,
                                    });
                                });

                                return r;
                        })
                        .catch((e) => { 
                            mensajesAlerta(e,error); 
                            return e;
                        });
                }
            },
            leerArchivo(objeto){
                if(!_.isUndefined(event)){
                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': objeto.path})
                         .then((r)=>{
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                this.objPdf.titulo = 'Formulario de Prevención de Lavado de Activos';
                                this.objPdf.mostrar = true;
                         })
                        .catch((e) => {
                            mensajesAlerta(e,error);
                        });
                }
            },
            validar(){
                _.forEach(this.archivos,(v,k) => {
                    this.$set(this.objForm,k,_.omit(v,['icon','iconClass','load','band']));
                });
                this.next('objArchivos',this.archivos); 
            },
            abrirVentana (p) {
                this.$refs[p][0].click()
            },
            obtenerFile(e){
                try {
                    var obj = e.target;
                    if(obj.files.length == 0) throw mensajeEstandar.faltaArchivos;
                    if(obj.files[0].size > this.parametros.taMaxArchivo) throw mensajeEstandar.taMaximoArchivoPdf;

                        return new Promise((resolve,reject)=>{
                            var fr = new FileReader();

                            fr.readAsDataURL(obj.files[0]);
                            fr.addEventListener('load', () => {
                                this.archivos[obj.id].base = fr.result;
                                this.$forceUpdate();
                            });

                            return resolve(true);
                        })
                        .then((r)=>{
                            if(!r) throw mensajeEstandar.taMaximoArchivoPdf;
                                this.archivos[obj.id].subtitle  = obj.files[0].name;
                                this.archivos[obj.id].iconClass = 'indigo lighten-2 white--text';   
                                this.totalFiles += !this.archivos[obj.id].band ? 1 : 0;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'I');
                        })


                } catch (error) {
                    this.archivos[obj.id].subtitle  = '';
                    this.archivos[obj.id].iconClass = 'grey lighten-1 white--text';
                    mensajesAlerta(mensajeEstandar.taMaximoArchivoPdf,'I');
                }
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf : this.cerrarModalPdf
            }
        }
    }
</script>